import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Alertc, AlertcPoint } from 'app/models';
import { DirectionType } from 'app/models/enums';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { enumValues } from 'app/shared/util/enumValues';

@Component({
  selector: 'point-details-vild',
  templateUrl: './point-details-vild.component.html',
  styleUrls: ['./point-details-vild.component.scss']
})
export class PointDetailsVildComponent implements OnInit, OnChanges {
  @Input() id: string;
  @Input() readonly: boolean;
  @Input() inputStyle: CbmInputStyle;
  @Input() alertcPoint: AlertcPoint;

  public alertc: Alertc;
  public directionTypes: string[];

  constructor() {}

  ngOnInit(): void {
    this.directionTypes = enumValues(DirectionType);
    this.alertc = new Alertc().getAlertc(this.alertcPoint);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.alertc = new Alertc().getAlertc(this.alertcPoint);
  }

  public getAlertcPoint(): AlertcPoint {
    this.alertcPoint.vildLocation = this.alertc.vildLocation;
    this.alertcPoint.offsetDistance = this.alertc.offsetDistance;
    this.alertcPoint.displayLatitude = this.alertc.latitude;
    this.alertcPoint.displayLongitude = this.alertc.longitude;
    this.alertcPoint.carriageway = this.alertc.carriageway;

    return this.alertcPoint;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/point-details/vild/point-details-vild.component.ts